<!-- <app-side-menu id="dashboard-side-menu" [isOpen]="(largeScreen$ | async) ?? false"></app-side-menu> -->

<app-side-bar id="dashboard-side-menu" menuState="'open'" />

<div id="dashbaord-noise-gradient"></div>

<div id="dashboard-content" [@routeTransition]="route.snapshot" >
    <router-outlet id="outlet"></router-outlet>
</div>